import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { ChangeProduct } from '../../components/product/changeProduct/change-product';
import NOB from '../../../../constants/language-strings';
import { formatDeviceSerialNumbers } from '../../helpers';
import { useProductActions } from 'modules/CustomerProducts/api';
import { LinkingContainer } from '../Linking/linking-container';
import { Icon } from '@purpurds/purpur/icon';
import { icons } from 'theme/icons';
import styled from 'styled-components';
import { purpurColorRed600 } from '@purpurds/tokens/color/variables';
import { Modal } from 'components/modal';
import { PurPurButton } from 'components';
import spacing from 'theme/spacing';
import { SlideInModal } from 'components/slide-in-modal';
const ProductContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${spacing.spacing70} 0 ${spacing.spacing20};
  max-width: 750px;
  min-width: 320px;
  width: calc(100% - 20px);
`;
const StyledDeleteWrapper = styled.div `
  display: flex;
  align-items: flex-end;
  font-size: 18px;
  cursor: pointer;
`;
const StyledIcon = styled(Icon) `
  color: ${purpurColorRed600};
  margin-right: ${spacing.spacing4};
`;
const StyledButtonContainer = styled.div `
  display: flex;
  justify-content: space-between;
  gap: 1rem;

  @media (max-width: 750px) {
    flex-direction: column;
  }
`;
const StyledButtonWrapper = styled.div `
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: ${spacing.spacing16};
`;
export const SingleProduct = ({ product, customerId, display, close, }) => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const productId = product.productId;
    const { deleteProduct, resetSwapDeviceSerial, errors, isProductFetching, } = useProductActions(customerId, productId, product.agreementDetailId);
    const onDeleteConfirmed = () => {
        deleteProduct();
        close();
        setShowDeleteModal(false);
    };
    return (_jsx(SlideInModal, { display: display, onClose: close, mainHeading: product.name, subHeading: formatDeviceSerialNumbers(product.devices), isFetching: isProductFetching, cleanUp: resetSwapDeviceSerial, children: _jsxs(ProductContainer, { children: [_jsx(LinkingContainer, { productId: product.productId, customerId: customerId, product: product, isProductFetching: isProductFetching }), product.devices.length > 0 && (_jsx(ChangeProduct, { product: product, customerId: customerId })), product.canBeRemoved && (_jsxs(StyledDeleteWrapper, { onClick: () => setShowDeleteModal(true), children: [_jsx(StyledIcon, { svg: icons.remove }), NOB.CHANGE_PRODUCT.REMOVE_UNIT] })), showDeleteModal && (_jsx(Modal, { isOpen: showDeleteModal, title: NOB.REMOVE_PRODUCT_POPUP.REMOVE_PRODUCT, onClose: () => setShowDeleteModal(false), actionButtons: _jsxs(StyledButtonContainer, { children: [_jsx(StyledButtonWrapper, { children: _jsx(PurPurButton, { size: "sm", type: "button", variant: "secondary", onClick: () => setShowDeleteModal(false), children: NOB.REMOVE_PRODUCT_POPUP.CANCEL }) }), _jsx(StyledButtonWrapper, { children: _jsx(PurPurButton, { size: "sm", type: "button", variant: "destructive", onClick: onDeleteConfirmed, children: NOB.REMOVE_PRODUCT_POPUP.REMOVE }) })] }), children: NOB.REMOVE_PRODUCT_POPUP.REMOVE_PRODUCT_QUESTION }))] }) }));
};
